module.exports = __webpack_public_path__ + "59b415eb8e6a1cf9f1c01be17ffe309c.png";